import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Container,
} from "@chakra-ui/react";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import Tab from "components/Tab/Tab";

// Panels

import Data from "./Panels/Data";
import Airtime from "./Panels/Airtime";

const Bills = (props) => {
  const currentPage = "Voucher";
  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="bills">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="container.xl">
            <Tabs variant="ghost" colorScheme="green">
              <TabList
                bg="white"
                borderRadius={[0, "8px"]}
                overflowX="overlay"
                sx={{
                  "::-webkit-scrollbar": {
                    h: "2px",
                  },
                }}
              >
                <Tab>Data</Tab>
                <Tab>Airtime</Tab>
              </TabList>

              <TabPanels>
                <TabPanel px="0">
                  <Data />
                </TabPanel>
                <TabPanel px="0">
                  <Airtime />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default Bills;
